import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  DOCUMENT,
  inject
} from '@angular/core';
import { CoreUtilsService } from '@bepatient/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'bepatient-info-message',
  templateUrl: './info-message.component.html',
  styleUrls: ['./info-message.component.scss'],
  standalone: false
})
export class InfoMessageComponent implements AfterViewInit, OnInit {
  document = inject(DOCUMENT);
  private element = inject(ElementRef);
  private domSanitizer = inject(DomSanitizer);
  private coreUtilsService = inject(CoreUtilsService);

  @Input() color: string;
  @Input() content: string;
  @Input() blocking: number;
  @Input() buttonLabel: string;
  @Input() showButton: boolean;
  @Input() icon: string;
  @Output() validated = new EventEmitter<boolean>();

  safeHtml: SafeHtml;
  spinner: HTMLElement;

  get buttonTextColor(): string {
    try {
      return this.coreUtilsService.getAccessibleTextColor(this.color);
    } catch {
      return '#ffffff';
    }
  }

  ngOnInit(): void {
    if (this.content) {
      const parsedContent = this.content.replace(
        /<img/g,
        `<img id='info-content-img'`
      );
      this.safeHtml = this.domSanitizer.bypassSecurityTrustHtml(parsedContent);
    }
  }

  ngAfterViewInit() {
    // Adding spinner
    this.spinner = document.createElement('ion-spinner');
    this.spinner.setAttribute('name', 'dots');
    this.spinner.style.alignSelf = 'center';
    this.spinner.style.top = '16px';

    const img = document.getElementById('info-content-img');
    this.element.nativeElement.children[0].prepend(this.spinner);

    if (!img) {
      this.spinner.remove();
    } else {
      img.style.marginBottom = 'calc(var(--ion-margin) * 2)';
      img.addEventListener('load', () => {
        this.spinner.remove();
      });
      img.addEventListener('error', () => {
        this.spinner.remove();
      });
    }
  }
}
